import myaxios from 'myaxios';
import * as appconst from '../appconst';
import localStorageService from "./localStorageService";

class UserService {
    ls = window.localStorage

    getAllUsers = async () => {
        const a = new Promise((resolve, reject) => {
            myaxios.get(appconst.USER + "/all")
                .then(res => {
                    return resolve(res.data.UserDetail);
                })
                .catch((error) => {
                    console.log("error", error);
                })
        });
        return await a;
    }

    getAllUsersWithPagination = async (pagenumber) => {
        const a = new Promise((resolve, reject) => {
            myaxios.get(appconst.USER + "/all" + "?page=" + pagenumber,)
                .then(res => {
                    return resolve(res.data.UserDetail);
                })
                .catch((error) => {
                    console.log("error", error);
                })
        });
        return await a;
    }

    getAllUsersByEmail = async (email_address) => {
        const a = new Promise((resolve, reject) => {
            myaxios.get(appconst.USER + "/all/email/"+email_address)
                .then(res => {
                    return resolve(res.data.UserDetail);
                })
                .catch((error) => {
                    console.log("error", error);
                })
        });
        return await a;
    }

    getActiveApplicantUsersByEmail = async (email_address) => {
        const a = new Promise((resolve, reject) => {
            myaxios.get(appconst.USER + "/all/active_applicant/email/"+email_address)
                .then(res => {
                    return resolve(res.data.UserDetail);
                })
                .catch((error) => {
                    console.log("error", error);
                })
        });
        return await a;
    }
    
    getAllUserDetailsById = async (id) => {
        const a = new Promise((resolve, reject) => {
            myaxios.get(appconst.USER + "/details/all/id/"+id)
                .then(res => {
                    return resolve(res.data.UserDetail);
                })
                .catch((error) => {
                    console.log("error", error);
                })
        });
        return await a;
    }

    getAllOfficers = async () => {
        const a = new Promise((resolve, reject) => {
            myaxios.get(appconst.USER + "/all/officer")
                .then(res => {
                    return resolve(res.data.User);
                })
                .catch((error) => {
                    console.log("error", error);
                })
        });
        return await a;
    }

    getAllUserDetailsByIdSystem = async () => {
        const auth_user= await localStorageService.getItem("auth_user");

        const a = new Promise((resolve, reject) => {
            myaxios.get(appconst.USER + "/details/all/system/id", {
                headers: { Authorization: `Bearer ${auth_user.token}` }
              })
                .then(res => {
                    return resolve(res.data.UserDetail);
                })
                .catch((error) => {
                    console.log("error", error);
                })
        });
        return await a;
    }

    sendPasswordResetLink = async(data) => {
        const a = new Promise((resolve, reject) => {
            myaxios.post(appconst.USER + "/send_password_reset_link", data).then(res => {
                    return resolve(res);
                })
                .catch((error) => {
                    console.log("error", error);
                })
        });
        return await a;
    }

    createUser = async(data) => {
        const a = new Promise((resolve, reject) => {
            myaxios.post(appconst.USER + "/create", data).then(res => {
                    return resolve(res);
                })
                .catch((error) => {                    
                    console.log("error", error);
                    return resolve(error);
                })
        });
        return await a;
    }

    updateStatus = async(status, id) => {
        const a = new Promise((resolve, reject) => {
            myaxios.put(appconst.USER + "/update/"+status+"/"+id).then(res => {
                    return resolve(res);
                })
                .catch((error) => {
                    console.log("error", error);
                })
        });
        return await a;
    }

    updateCounter = async(counter, id) => {
        const a = new Promise((resolve, reject) => {
            myaxios.put(appconst.USER + "/counter/update/"+counter+"/"+id).then(res => {
                    return resolve(res);
                })
                .catch((error) => {
                    console.log("error", error);
                })
        });
        return await a;
    }


    updateUserDetails = async(data, id) => {
        const a = new Promise((resolve, reject) => {
            myaxios.put(appconst.USER + "/details/update/"+id, data).then(res => {
                    return resolve(res);
                })
                .catch((error) => {
                    console.log("error", error);
                })
        });
        return await a;
    }
    
    changePicture = async(data, config, id) => {
        const a = new Promise((resolve, reject) => {
            myaxios.post(appconst.USER + "/details/photo/update/"+id, data, config).then(res => {
                    return resolve(res);
                })
                .catch((error) => {
                    console.log("error", error);
                })
        });
        return await a;
    }

    changePassword = async(data, id) => {
        const a = new Promise((resolve, reject) => {
            myaxios.put(appconst.USER + "/password/update/"+id, data).then(res => {
                    return resolve(res);
                })
                .catch((error) => {
                    console.log("error", error);
                })
        });
        return await a;
    }

    resetPassword = async(data, id) => {
        const a = new Promise((resolve, reject) => {
            myaxios.put(appconst.USER + "/password/reset/"+id, data).then(res => {
                    return resolve(res);
                })
                .catch((error) => {
                    console.log("error", error);
                })
        });
        return await a;
    }

}
export default new UserService();